module.exports = __webpack_public_path__ + "5d601f3c2e05289f5246d4787da221d5.png";